import moment from 'moment-timezone'
import {
  ADD_NEW_FACTOR,
  GET_CURRENT_COLLECTION,
  DELETE_CURRENT_COLLECTION,
  GET_PRESETS,
  GET_RESULTS_FOR_COLLECTION,
  SET_CURRENT_FACTORS,
  SET_TEMPLATE_FACTORS,
  // CREATE_QUESTIONS_START,
  // CREATE_QUESTIONS_SUCCESS,
  // CREATE_QUESTIONS_ERROR,
  // CREATE_QUESTIONS_DONE,
  UPDATE_QUESTION_SUCCESS,
  DELETE_QUESTION_SUCCESS,
  FETCH_COLLECTION_START,
  FETCH_COLLECTION_SUCCESS,
  FETCH_COLLECTION_DONE,
  CREATE_PRESET_QUESTIONS_SUCCESS,
  CREATE_PRESET_QUESTIONS_ERROR,
  CREATE_PRESET_QUESTIONS_DONE,
  SET_CURRENT_PRESET,
  GET_QUESTIONS_BY_COLLECTION_ID_START,
  GET_QUESTIONS_BY_COLLECTION_ID_SUCCESS,
  GET_QUESTIONS_BY_COLLECTION_ID_ERROR,
  GET_QUESTIONS_BY_COLLECTION_ID_DONE,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_ERROR,
  GET_COMMENTS_DONE,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_ERROR,
  POST_COMMENT_DONE,
} from '../actions/actionTypes'
import initialState from './initialState'

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_NEW_FACTOR:
      const updatedPreset = { ...state.presets }
      updatedPreset[action.preset] = [...updatedPreset[action.preset], '']
      return {
        ...state,
        presets: { ...updatedPreset },
      }
    case FETCH_COLLECTION_START:
      return {
        ...state,
        collectionLoading: true,
      }
    case GET_CURRENT_COLLECTION:
    case FETCH_COLLECTION_SUCCESS:
      const newCollection = { ...action.payload }
      // remove ", newCollection.timezone" if date_time has timezone '2020-12-22T12:01:09-08:00'
      // __________________________________time in UTC_____timezone from the backend___to local time
      newCollection.end_on = moment
        .tz(newCollection.end_on, newCollection.timezone)
        .local()
        .format()
      return {
        ...state,
        collection: newCollection,
        currentFactors: [...newCollection.questions],
        collectionLoading: false,
      }
    case FETCH_COLLECTION_DONE:
      return (({ collectionLoading, ...other }) => ({ ...other }))(state)
    case DELETE_CURRENT_COLLECTION:
      return (({ collection, ...other }) => ({ ...other }))(state)
    case GET_PRESETS:
      return {
        ...state,
        presets: [...action.payload],
      }
    case SET_CURRENT_FACTORS:
      return {
        ...state,
        currentFactors: [...action.payload],
      }
    case SET_CURRENT_PRESET:
      return {
        ...state,
        currentPreset: action.payload,
      }
    case CREATE_PRESET_QUESTIONS_SUCCESS:
      return {
        ...state,
        createQuestionsSuccess: true,
      }
    case CREATE_PRESET_QUESTIONS_ERROR:
      return {
        ...state,
        createQuestionsError: true,
      }
    case CREATE_PRESET_QUESTIONS_DONE:
      return (({ createQuestionsError, createQuestionsSuccess, ...other }) => ({
        ...other,
      }))(state)
    case UPDATE_QUESTION_SUCCESS:
    case DELETE_QUESTION_SUCCESS:
      return {
        ...state,
        // currentFactors: [...action.payload.questions]
      }
    case SET_TEMPLATE_FACTORS:
      return {
        ...state,
        templateFactors: [...action.payload],
      }
    case GET_RESULTS_FOR_COLLECTION:
      return {
        ...state,
        results: [...action.payload],
      }
    case GET_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.id]: action.payload.comments,
        },
      }
    case GET_COMMENTS_ERROR:
    case GET_COMMENTS_DONE:
      return {
        ...state,
      }

    case POST_COMMENT_SUCCESS:
      const { id, comment } = action.payload
      return {
        ...state,
        comments: {
          ...state.comments,
          [id]: [...state.comments[id], comment],
        },
      }
    case POST_COMMENT_ERROR:
    case POST_COMMENT_DONE:
      return {
        ...state,
      }

    case GET_QUESTIONS_BY_COLLECTION_ID_SUCCESS:
      return {
        ...state,
        templateFactors: action.payload,
      }
    case GET_QUESTIONS_BY_COLLECTION_ID_START:
    case GET_QUESTIONS_BY_COLLECTION_ID_ERROR:
    case GET_QUESTIONS_BY_COLLECTION_ID_DONE:
      return {
        ...state,
      }

    default:
      return {
        ...state,
      }
  }
}
